import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

import FacteurEditeur from "./pages/FacteurEditeur";
import Historique from "./pages/Historique";
import Home from "./pages/home";
import Admin from "./pages/Admin";
import "./App.css";
import { PrimeReactProvider } from 'primereact/api';

function App() {
  return (
    <PrimeReactProvider>
      <Router>
        <Switch>
          <Route exact path="/" component={Home} />
          <Route path="/facteur-editeur" component={FacteurEditeur} />
          <Route path="/historique" component={Historique} />
          <Route path="/admin" component={Admin} />
        </Switch>
      </Router>
    </PrimeReactProvider>
  );
}

export default App;
